export enum DataStoreEvent {
  updateState = 'update-state',
}
